import request from '@/utils/request'

/**
 * 获取所有印章规则
 */
export function getSealRules() {
  return request({
    url: '/signstore/sealrule/list',
    method: 'get'
  })
}

/**
 * 对比印章点位相似度（ACT004 专用）
 * @param {Object} data - ruleCode、touchPoints、authStoreCode、coordinateSystem、remark 等
 */
export function compareSealPointsAct004(data) {
  return request({
    url: '/signstore/sealrule/compareSimilarity/act004',
    method: 'post',
    data: {
      ruleCode: data.ruleCode,
      touchPoints: data.touchPoints,
      activityUserId: data.activityUserId || null,
      authStoreCode: data.authStoreCode,
      coordinateSystem: data.coordinateSystem != null ? data.coordinateSystem : 1
    }
  })
}

/**
 * 对比印章点位相似度（通用打卡接口）
 * @param {Object} data - 包含 ruleCode、touchPoints 和可选的 activityUserId
 */
export function compareSealPoints(data) {
  return request({
    url: '/signstore/sealrule/compareSimilarity',
    method: 'post',
    data: {
      ruleCode: data.ruleCode,
      touchPoints: data.touchPoints,
      activityUserId: data.activityUserId || null,
      authStoreCode: data.authStoreCode
    }
  })
}

/**
 * 追加印章点位到规则
 * @param {Object} data - 包含 ruleCode、sealPoints（4个点位）
 */
export function addSealPoints(data) {
  return request({
    url: '/signstore/sealrule/addSealPoints',
    method: 'post',
    data: {
      ruleCode: data.ruleCode,
      sealPoints: data.sealPoints,
      coordinateSystem: data.coordinateSystem,
      remark: data.remark
    }
  })
}

